import { AppState } from '..'
import { useAppSelector } from '../hooks'

export const useFileSearchValue = () => {
  return useAppSelector((state: AppState) => {
    return state.fileSearchStore.value
  })
}
